<template>
    <div class="multi-step">
        <ul class="multi-step-list">
          <li v-for="(tab, index) in tabs" :key="index" class="multi-step-item" :class='{"current": (index === selected)}'>
            <div class="item-wrap">
              <p class="item-title">{{tab}}</p>
            </div>
          </li>
        </ul>
      </div>
</template>
<script>
    export default { 
        props: ['tabs', 'selected']
    };
</script>